import Vue from 'vue'
import VueRouter from 'vue-router'
import Shouye from "@/views/Shouye";
import Zhengshu from "@/views/Zhengshu";
import Anli from "@/views/Anli";
import Chanpin from "@/views/Chanpin";
import Lianxi from "@/views/Lianxi";


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Shouye',
        component: Shouye
    },
    {
        path: '/Shouye',
        name: 'Shouye',
        component: Shouye
    },
    {
        path: '/Zhengshu',
        name: 'Zhengshu',
        component: Zhengshu
    },
    {
        path: '/Chanpin',
        name: 'Chanpin',
        component: Chanpin
    },
    {
        path: '/Anli',
        name: 'Anli',
        component: Anli
    },
    {
        path: '/Lianxi',
        name: 'Lianxi',
        component: Lianxi
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router